/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { faker } from '@faker-js/faker/locale/en';
import { BeginJobExecutionRequest } from '../JobExecution';

export const createMockBeginJobExecutionRequest = (
  partialRecord: Partial<BeginJobExecutionRequest> = {},
): BeginJobExecutionRequest => {
  const input = faker.helpers.arrayElement([
    faker.datatype.boolean(),
    faker.lorem.word(),
    faker.number.int(),
    { [faker.lorem.word()]: faker.lorem.words() },
    null,
  ]);

  return {
    context: faker.string.uuid(),
    jobName: faker.lorem.word(),
    input,
    ...partialRecord,
  };
};
